<!--

cardInfo = [{
  cardProtoCode:"fullnet-vir-net",
  expireDate:"2019-10-23",
  gainId:10004,
  gainTime:"2018-10-23 17:01:51",
  number:"RDMfullnetvirnet30x1221401333490611",
  openTime:"2018-10-24 13:40:45",
  opened:true,
  secret:"CY25SJfWLczALqxx",
  skuImageUrl:"http://resource.uwan99.com/hk_data/a16f5c32-2840-4be1-9064-f937e8023cec",
  skuName:"30M流量",
}]
-->
<template>
    <div class="charge">
         <TopCtrl/>
        <img class="pro-image" :src="cardInfo.skuImageUrl" alt="">
        <div class="detail">
            <div class="title">
                <span class="m-brage">全国通用</span>
                <span>{{cardInfo.skuName}}</span>
            </div>
            <div class="indate">
                <p>有效期至： {{cardInfo.expireDate}}</p>
            </div>
            <div class="phone">
                <span>手机号码</span>
                <input type="text" v-model="phone" placeholder="请输入充值手机号码">
            </div>

        </div>
        <ActionButton text="立即充值" @click="Charge" />
    </div>
</template>

<script>
    import ActionButton from '@/components/products/form/ActionButton'
    import api from "../../api";

    export default {
        title: "卡密充值",
        bodyClass: "gray-bg",
        components: {
            ActionButton
        },
        data() {
            return {
                phone: '',
                cardInfo: {},
            }
        },
        methods: {
            init () {
                let gainId = this.$route.query.gainId;
                api.wallet.secret(gainId, (data) => {
                    this.cardInfo = data.cardInfo
                }, r => {
                    this.$alertDialog(r.msg)
                })
            },
            Charge () {
                let gainId = this.$route.query.gainId;
                let p = this.phone;
                let reg = /^[1][3,4,5,7,8][0-9]{9}$/;
                if (p == '') {
                    this.$toast('请输入手机号码');
                    return
                }
                if (!reg.test(p)) {
                    this.$toast('请输入正确的手机号码');
                    return
                }

                api.wallet.charge(gainId, p, (data) => {
                    this.$toast(data.msg);
                    this.phone = ''
                }, r => {
                    this.$alertDialog(r.msg);
                })
            }
        },
        mounted() {
            this.init()
        },
    }
</script>

<style lang="less" scoped>
    .charge {
        .pro-image {
            width: 100%;
        }

        .detail {
            padding: 5vw;
            .title {
                display: flex;
                align-items: center;
                .m-brage {
                    color: #f50037;
                    border: 1px solid #f50037;
                    border-radius: 10px;
                    padding: .5vw 2vw;
                    font-size: 3.5vw;
                    margin-right: 3vw;
                }
            }
            .indate {
                font-size: 3.5vw;
                color: #999;
            }
            .phone {
                margin-top: 10vw;

                input {
                    margin-left: 5vw;
                    height: 9vw;
                    width: 60vw;
                    padding-left: 3vw;
                    font-size: 3.5vw;
                }
                input::placeholder {
                    color: #999
                }
            }
        }

        .wrap {
            position: relative;
            background: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/orders/Charge.vue